import React, { useEffect } from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";
const Drawer = ({ open, onClose, title, children , isBack }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (open) document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={onClose}
        />
      )}

      <div
        className={`fixed top-0 px-3 pt-4 right-0 z-50 h-full w-full sm:w-[480px] bg-white shadow-lg transform transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex bg-slate-100 rounded-[10px] justify-between items-center p-3 border-b">
          <div className="flex items-center gap-2">
            {isBack&& (
              <MdOutlineArrowBackIos className=" text-primary font-semibold text-xl" onClick={onClose} />
            )}
          
          <h2 className="text-lg text-primary font-semibold">{title}</h2>
          </div>
          
          <button
            onClick={onClose}
            className="text-red-500 bg-white rounded-full w-8  h-8 text-center flex justify-center items-center text-xl leading-none hover:text-gray-800"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">{children}</div>
      </div>
    </>
  );
};

export default Drawer;
